/**
 * Permissions Matrix Dialog
 *
 * A minimal dialog wrapper that displays the PermissionsMatrix component.
 * The close button is part of the PermissionsMatrix card itself.
 */

import { Dialog } from '@mui/material';

import { PermissionsMatrix } from './PermissionsMatrix';

interface PermissionsMatrixDialogProps {
  open: boolean;
  onClose: () => void;
}

export function PermissionsMatrixDialog({ open, onClose }: PermissionsMatrixDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          // Remove default Dialog padding since the Card has its own styling
          overflow: 'hidden',
        },
      }}
    >
      <PermissionsMatrix onClose={onClose} />
    </Dialog>
  );
}
